import { SeeqNames } from 'generated-seeqnames/app.constants.seeqnames';
import { getOrigin, getOriginLabel, getOriginUrl } from '@/utilities/http.utilities';
import type { SeeqInternalAxiosRequestConfig } from '@/requests/axios.utilities';

export function requestOriginInterceptor(config: SeeqInternalAxiosRequestConfig) {
  if (config.headers) {
    config.headers[SeeqNames.API.Headers.RequestOrigin] = getOrigin();
    config.headers[SeeqNames.API.Headers.RequestOriginURL] = getOriginUrl();
    config.headers[SeeqNames.API.Headers.RequestOriginLabel] = getOriginLabel();
  }
  return config;
}
